import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tab", "panel"]
  static values = { default: String }

  connect() {
    // Restore saved tab or use default
    const savedTab = localStorage.getItem("dashboard-tab") || this.defaultValue || "intake"
    this.showTab(savedTab)
  }

  switch(event) {
    event.preventDefault()
    const tabName = event.currentTarget.dataset.tabsName
    this.showTab(tabName)
    localStorage.setItem("dashboard-tab", tabName)

    // Update URL hash for bookmarkability
    history.replaceState(null, null, `#${tabName}`)
  }

  showTab(tabName) {
    // Update tab buttons
    this.tabTargets.forEach(tab => {
      if (tab.dataset.tabsName === tabName) {
        tab.classList.add("active")
        tab.setAttribute("aria-selected", "true")
      } else {
        tab.classList.remove("active")
        tab.setAttribute("aria-selected", "false")
      }
    })

    // Update panels
    this.panelTargets.forEach(panel => {
      if (panel.dataset.tabsName === tabName) {
        panel.classList.remove("d-none")
      } else {
        panel.classList.add("d-none")
      }
    })
  }
}
